module.exports = __webpack_public_path__ + "assets/ic_condition_05.ce859436.svg";